export default "__VITE_ASSET__DFC5GKU0__"